import { AutoSelection, Box, Combobox, InlineStack, Listbox, Tag } from "@shopify/polaris";
import { useCallback, useEffect, useState } from "react";

interface ExclusionListProps {
  exclusionCodes: string[] | undefined;
  onChange: (exclusionCodes: string[]) => void;
}

export const ExclusionList = ({ exclusionCodes, onChange }: ExclusionListProps) => {
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [value, setValue] = useState("");

  useEffect(() => {
    if (exclusionCodes) {
      setSelectedTags(exclusionCodes);
    }
  }, [exclusionCodes]);

  const updateSelection = useCallback(
    (selected: string) => {
      const nextSelectedTags = new Set([...selectedTags]);

      if (nextSelectedTags.has(selected)) {
        nextSelectedTags.delete(selected);
      } else {
        nextSelectedTags.add(selected);
      }
      setSelectedTags([...nextSelectedTags]);
      onChange([...nextSelectedTags]);
      setValue("");
    },
    [selectedTags, onChange],
  );

  const removeTag = useCallback(
    (tag: string) => () => {
      updateSelection(tag);
    },
    [updateSelection],
  );

  const verticalContentMarkup =
    selectedTags.length > 0 ? (
      <InlineStack align="start" blockAlign="center" gap="100">
        {selectedTags.map((tag) => (
          <Box>
            <Tag key={`option-${tag}`} onRemove={removeTag(tag)}>
              {tag}
            </Tag>
          </Box>
        ))}
      </InlineStack>
    ) : null;

  const listboxMarkup = (
    <Listbox autoSelection={AutoSelection.None} onSelect={updateSelection}>
      {value.trim() !== "" && !selectedTags.includes(value.trim()) && (
        <Listbox.Action value={value.trim()}>{`Add "${value.trim()}"`}</Listbox.Action>
      )}
    </Listbox>
  );

  return (
    <div>
      <Combobox
        activator={
          <Combobox.TextField
            autoComplete="off"
            label="Enter Discount Codes"
            labelHidden
            onChange={setValue}
            placeholder="Enter Discount Codes"
            value={value}
            verticalContent={verticalContentMarkup}
          />
        }
        allowMultiple
      >
        {listboxMarkup}
      </Combobox>
    </div>
  );
};
